/********************************************
* Dismissible message
********************************************/
function fnDismissibleMessage( i, oMessage ) {

	var oMessage 				= $( oMessage ),
		oExitButton				= $( 'i.exit', oMessage ),
		sDataID					= 'COVID19_NOTICE';

	/**
	* Store data
	*/
	function fnStoreData() {
		localStorage.setItem( sDataID, 'TRUE' );
		oMessage.addClass( 'hidden' );
	}

	/**
	* Check if data is already stored
	*/
	if ( localStorage.getItem( sDataID ) ) {
		fnStoreData();
	}

	/**
	* On-click (store data)
	*/
	oExitButton.on( 'click', function(e) {
		e.preventDefault();
		fnStoreData();
	} );

}


// END OF DOCUMENT